// extracted by mini-css-extract-plugin
export default {"registrationLanguageSelect":"registration-language-select_registrationLanguageSelect__W+4y6"};